import React from 'react';
import PageFooter from '../../componentParts/footer';
import TopNav from '../../componentParts/topNav';
import Fade from 'react-reveal/Fade';
import { Light, MoneyOutlined, Timer } from '@mui/icons-material';
import { Transfer } from 'antd';
import { CustomerServiceFilled } from '@ant-design/icons';

function WayaLoan() {

    return (
        <div className='w-100'>
            <TopNav />
            <div className="position-relative pt-5 " style={{ backgroundImage: 'url(/grain.png)', }}>
                <div className={`container-fluid w-100 pt-5 px-lg-5`}>
                    <div className="row py-md-5">
                        <div className='col-md-6'>
                            <Fade left className='w-100'>
                                <h2 className="text-dark mt-5 my-lg-5 fs-1 fw-bold">Waya Loan</h2>
                                <p className='fs-5 fw-bold pe-md-5'>Access quick and affordable loans to meet your personal and business needs. Waya Loan offers a seamless application process, competitive interest rates, and flexible repayment options.</p>
                                <div className='w-100 py-4'>
                                    <div className='row'>
                                        <div className='my-3 col-md-6'>
                                            <a href={'https://sites.google.com/view/wayamfbloan?usp=sharing'} className='w-100 btn btn-orange fs-5 rounded-15p btn-lg py-3'>Apply for a Loan</a>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='my-3 col-md-4'>
                                            <a href={'https://play.google.com/store/apps/details?id=com.wayamfb.wayamfbmobile'}><img alt='waya' src='/images/play-store.png' className='w-100' /></a>
                                        </div>
                                        <div className='my-3 col-md-4'>
                                            <a href={'https://apps.apple.com/us/app/wayabank-mobile/id6747767226'}><img alt='waya' src='/images/app-store.png' className='w-100' /></a>
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                        </div>
                        <div className='col-md-6 w-100'>
                            <Fade right>
                                <div className='w-100 text-center'>
                                    <img src={`/images/wayaloan/loan-hero.png`} className="img-fluid w-75 mx-auto" alt='jumbotron' />
                                </div>
                            </Fade>
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-100 bg-light">
                <Fade bottom>
                    <div className='container py-4'>
                        <div className='row py-4'>
                            <div className={`col-12 col-md-3 my-2`}>
                                <div className='w-100 shadow-sm rounded-15p text-center pb-3 bg-white'>
                                    {/* <img alt='waya' src={"/images/wayaloan/timer.png"} className="my-md-3 img-fluid" /> */}
                                    <Timer />
                                    <p className='fw-bold m-0 p-0'>Quick Access</p>
                                </div>
                            </div>
                            <div className={`col-12 col-md-3 my-2`}>
                                <div className='w-100 shadow-sm rounded-15p text-center pb-3 bg-white'>
                                    {/* <img alt='waya' src={"/images/wayaloan/light.png"} className="my-md-3 img-fluid" /> */}
                                   <Light />
                                    <p className='fw-bold m-0 p-0'>Competitive Rates</p>
                                </div>
                            </div>
                            <div className={`col-12 col-md-3 my-2`}>
                                <div className='w-100 shadow-sm rounded-15p text-center pb-3 bg-white'>
                                    {/* <img alt='waya' src={"/images/wayaloan/transfer-back.png"} className="my-md-3 img-fluid" /> */}
                                   <MoneyOutlined />
                                    <p className='fw-bold m-0 p-0'>Flexible Repayment</p>
                                </div>
                            </div>
                            <div className={`col-12 col-md-3 my-2`}>
                                <div className='w-100 shadow-sm rounded-15p text-center pb-3 bg-white'>
                                    {/* <img alt='waya' src={"/images/wayaloan/customer-care.png"} className="my-md-3 img-fluid" /> */}
                                    <CustomerServiceFilled />
                                    <p className='fw-bold m-0 p-0'>24/7 Support</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fade>
            </div>
            <PageFooter />
        </div>
    )
}

export default WayaLoan;
